module.exports = __webpack_public_path__ + "img/corporate_banner.5e7f6389.png";